import PropTypes from 'prop-types';

export const AccordionItem = {
    id: PropTypes.number,
    question: PropTypes.string,
    answer: PropTypes.string
};
